export default __webpack_public_path__ + "static/media/empty-landing.c56aa9af.png";